import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const MuiTextField: Components<Theme>['MuiTextField'] = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      ...(!ownerState.multiline && {
        '& .MuiOutlinedInput-root': {
          height: 56,
        },
      }),
    }),
  },
};
